import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sprout, Share2 } from 'lucide-react';
import { Button } from '../components/ui/button';

/**
 * Fallback landing when the OS routes a share intent to /share-target but
 * the service worker isn't yet installed on this device (very first visit,
 * or browser doesn't support service workers). We can't recover the shared
 * file on this path — a POST without a SW returns 404 by default. This
 * page explains what happened and points the user at the normal Add Plant
 * flow.
 *
 * On a device that HAS the SW installed, this route is never reached: the
 * SW intercepts, stashes the payload, and 303-redirects to /library?shared=1.
 */
const ShareTargetPage = () => {
  const navigate = useNavigate();
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 text-center" style={{ backgroundColor: 'hsl(82, 55%, 95%)' }}>
      <Share2 className="w-14 h-14 mb-4" style={{ color: 'hsl(143, 28%, 25%)' }} />
      <h1 className="font-display text-3xl font-bold mb-3" style={{ color: 'hsl(143, 28%, 25%)' }}>
        Almost there!
      </h1>
      <p className="text-base mb-6 max-w-md" style={{ color: 'hsl(125, 12%, 25%)' }}>
        Install the plant inventory as an app first, then share a photo to it again — the shared photo will open directly in the Add Plant screen.
      </p>
      <Button
        onClick={() => navigate('/')}
        style={{ backgroundColor: 'hsl(143, 28%, 25%)', color: 'white' }}
        data-testid="share-target-fallback-cta"
      >
        <Sprout className="w-4 h-4 mr-2" />
        Open plant inventory
      </Button>
    </main>
  );
};

export default ShareTargetPage;
